import InputField from './inputField'

export default InputField